import { store } from '../../store'

export { default } from './Deeplink'

export const deeplinked = () => {
  const state = store.getState()
  const deeplinkedTo = state?.deeplink?.deeplinkedTo

  if (!deeplinkedTo) {
    return false
  }

  if (typeof deeplinkedTo === 'boolean') {
    return deeplinkedTo
  }

  if (typeof deeplinkedTo === 'string') {
    const { pathname } = location
    return (
      deeplinkedTo === pathname ||
      navigatedToVideoDetails(deeplinkedTo, pathname)
    )
  }
}

const navigatedToVideoDetails = (deeplinkedTo, pathname) =>
  fromVideoPlayback(deeplinkedTo) && toVideoDetails(deeplinkedTo, pathname)
const fromVideoPlayback = (deeplinkedTo = '') =>
  deeplinkedTo?.includes('video-playback')
const toVideoDetails = (deeplinkedTo = '', pathname = '') =>
  pathname === deeplinkedTo.replace('video-playback', 'video-details')
